import { useState, useEffect } from 'react';
import { loadSearchStateFromLocalStorage } from './useLocalStorage';
import { SearchState } from '../types/search';

/**
 * Hook to manage search state (origin, destination, date, tripType, options)
 */
export const useSearchState = () => {
  const [originId, setOrigin] = useState<string>('');
  const [destinationId, setDestination] = useState<string>('');
  const [originName, setOriginName] = useState<string>('');
  const [destinationName, setDestinationName] = useState<string>('');
  const [date, setDate] = useState<string>(() => {
    const storedDate = localStorage.getItem('localDate');
    return storedDate || '';
  });
  const [tripType, setTripType] = useState<'departure' | 'arrival'>(() => {
    return (localStorage.getItem('localTripType') as 'departure' | 'arrival') || 'departure';
  });
  const [options, setOptions] = useState<Record<string, any>>({});

  // Load initial search state from localStorage (if URL doesn't have params)
  useEffect(() => {
    const savedState = loadSearchStateFromLocalStorage();
    if (savedState) {
      if (savedState.originId) setOrigin(savedState.originId);
      if (savedState.destinationId) setDestination(savedState.destinationId);
      if (savedState.date) setDate(savedState.date);
      if (savedState.tripType) setTripType(savedState.tripType);
      if (savedState.options) setOptions(savedState.options);
    }
  }, []);

  return {
    originId,
    setOrigin,
    destinationId,
    setDestination,
    originName,
    setOriginName,
    destinationName,
    setDestinationName,
    date,
    setDate,
    tripType,
    setTripType,
    options,
    setOptions,
  };
};
